import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Enteral Info</h3>
				<hr />
				<p>Are you prescribing more than one Enteral formula?</p>

				<div className="toggle">
					<div className={this.props.data.MultiEnteral == true ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('MultiEnteral', true) }}>Yes</div>
					<div className={this.props.data.MultiEnteral == false ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('MultiEnteral', false) }}>No</div>
				</div>

				{this.props.data.MultiEnteral ?
					<div>
						<p>All generically equivalent Enteral products must be combined into one Prior Authorization request. Have all generically equivalent Enterals been combined into one request?</p>
						<div className="toggle">
							<div className={this.props.data.SameCategory === true ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('SameCategory', true) }}>Yes</div>
							<div className={this.props.data.SameCategory === false ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('SameCategory', false) }}>No</div>
						</div>
						<br />
					</div> : ''}
				<br />

				{this.props.data.SameCategory === false ?
					<div>
						<p>If prescribing two or more Enteral products which are not generically equivalent, a separate Prior Authorization is needed for each Enteral product.  </p>
						<p>Once the first Prior Authorization request is complete, you will have the option to request another Prior Authorization. </p>
						<br />
					</div> : ''}
				<br />

				<div className="button" onClick={() => this.props.navigate('R10')}>Continue</div>
			</div>
		);

	}
}